import { AlertCircleIcon } from "lucide-react";
import type { Dictionary } from "../../../../dictionaries";
import { StatusOverlay } from "./status-overlay";

interface PaymentExpiredViewProps {
  onRetry: () => void;
  dictionary: Dictionary;
}

export function PaymentExpiredView({
  onRetry,
  dictionary,
}: PaymentExpiredViewProps) {
  const { status } = dictionary;

  return (
    <StatusOverlay
      icon={
        <div className="flex size-16 items-center justify-center rounded-full bg-muted">
          <AlertCircleIcon className="size-8 text-muted-foreground" />
        </div>
      }
      title={status.expired.title}
      description={status.expired.description}
      cancelLabel={status.expired.retry}
      onCancel={onRetry}
    />
  );
}
